import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { initI18n } from 'i18n';

import { I18N_CACHE_PREFIX } from '@shared/utils/i18n';

const I18nInitializer = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    // remove invalid cache to prevent i18n backend from being blocked by corrupted cache
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith(I18N_CACHE_PREFIX) && !key.endsWith('-lastmodified')) {
        const cachedData = localStorage.getItem(key);
        if (cachedData) {
          try {
            JSON.parse(cachedData);
          } catch (e) {
            localStorage.removeItem(key);
            console.error(`Removed invalid cached translation ${key} from localStorage.`, e);
          }
        } else {
          localStorage.removeItem(key);
        }
      }
    });
    initI18n();
  }, []);
  return <>{children}</>;
};

export default I18nInitializer;
